export const Tables = {
    YAHOO_ARBITRAGE: "O&O",
    OVERALL_TARGETS: "Overall",
    OVERPAYMENT: "Overpayment",
    DIVERSIFICATION: "Internal",
    THIRD_PARTIES: "3rd Parties",
    PUSH_NOTIFICATIONS: "Push Notifications",
}


// WEBPACK FOOTER //
// ./src/configs/target/constants.js